var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('kbd',[_vm._v(_vm._s(_vm.before))]),_vm._v(" → "),_c('kbd',[_vm._v(_vm._s(_vm.after))])])}
var staticRenderFns = []

export { render, staticRenderFns }